import { useEffect, useState } from 'react';
import { onDocAccessDenied, type AccessDeniedReason } from '../doc-access-denied-bus';

export type DocAccessStatus =
  | { state: 'allowed' }
  | { state: 'denied'; reason: AccessDeniedReason };

export function useDocAccessDeniedStatus(id: string | null): DocAccessStatus {
  const [status, setStatus] = useState<DocAccessStatus>({ state: 'allowed' });

  useEffect(() => {
    if (!id) { setStatus({ state: 'allowed' }); return; }
    setStatus({ state: 'allowed' });
    return onDocAccessDenied((deniedId, reason) => {
      if (deniedId === id) {
        setStatus({ state: 'denied', reason });
      }
    });
  }, [id]);

  return status;
}
